import { Components, Theme } from '@mui/material/styles';
import { getFocusRingStyle } from '@/src/components/focusring/focusring';

export const flowCheckbox: Components<Theme>['MuiCheckbox'] = {
  defaultProps: {
    disableRipple: true,
  },
  styleOverrides: {
    root: ({ theme, ownerState }) => ({
      zIndex: '0',
      flexShrink: '0',
      padding: '0',
      borderRadius: '2px',
      // checkbox itself
      '& svg': {
        // above hover effect
        position: 'relative',
        // still clickable
        zIndex: '20',
        pointerEvents: 'none',
      },
      // default unselected color
      '&, &:hover': {
        color: theme.palette.text.primary,
      },
      // 'primary' and other unsupported variants style ('success')
      '&.Mui-checked, &.MuiCheckbox-indeterminate': {
        '&, &:hover': {
          color: theme.palette.mode === 'dark' ? theme.palette.brand.secondary : theme.palette.brand.primary,
        },
      },
      // focus style
      ...getFocusRingStyle(theme, false, '1px'),
      // color variants
      ...(ownerState.color === 'secondary' && {
        '&, &.Mui-checked, &.MuiCheckbox-indeterminate': {
          '&, &:hover': {
            color: theme.palette.secondary.main,
          },
        },
      }),
      ...(ownerState.color === 'error' && {
        '&, &.Mui-checked, &.MuiCheckbox-indeterminate': {
          '&, &:hover': {
            color: theme.palette.error.main,
          },
        },
      }),
      // disabled style
      '&.Mui-disabled': {
        color: theme.palette.disabled.tertiary,
      },
    }),
  },
};
